import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import genderSelectionLoaderJson from '@/data/lottie-animations/genderSelectionLoader.json'

const schema: LandingScreenSchema = {
	config: {
		dynamicLandingType: 'main_loader',
	},

	order: [
		'LandingHead',
		'LandingTitle',
		'LandingImage', // <- if dynamicLandingData.image_url
		'LandingLottieAnimation', // else
		'LandingProgressLoader',
		'LandingFooter',
	],

	components: {
		LandingTitle: ({ $t, ctx }): LandingComponentsConfig['LandingTitle'] => ({
			title: ctx.dynamicLandingData?.title ?? $t('pages.landing.male_funnel.title'),
			size: 'small',
		}),

		LandingImage: ({ ctx }): LandingComponentsConfig['LandingImage'] => ({
			hide: !Boolean(ctx.dynamicLandingData?.image_url),
			img: ctx.dynamicLandingData.image_url,
			customStyles: {
				maxHeight: '50vh',
				marginTop: 'var(--size-16)',
				marginBottom: 'var(--size-16)',
			},
		}),

		LandingLottieAnimation: ({ ctx }): LandingComponentsConfig['LandingLottieAnimation'] => ({
			hide: Boolean(ctx.dynamicLandingData?.image_url),
			animationData: ctx.dynamicLandingData?.animation_url || genderSelectionLoaderJson,
			loop: true,
			customStyles: {
				height: '50vh',
			},
		}),

		LandingProgressLoader: ({ ctx }): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
			label: ctx.dynamicLandingData?.loader?.label,
			note: ctx.dynamicLandingData?.loader?.note,
		}),

		LandingFooter: ({ ctx }): LandingComponentsConfig['LandingFooter'] => ({
			description: ctx.dynamicLandingData?.feature_description,
			disclaimer: ctx.dynamicLandingData?.disclaimer,
		}),
	},
}

export default schema
